export default {
  // Header Section
  "discover_your": "உங்கள்",
  "gemstones": "ரத்தினங்கள்",
  "healing_crystal_guidance": "குணப்படுத்தும் கிரிஸ்டல் வழிகாட்டுதல்",
  "gemstones_description": "உங்கள் தனித்துவமான ஜாதகத்தின் அடிப்படையில் தனிப்பயன் ரத்தினங்களும் கிரிஸ்டல்களும் பற்றிய பரிந்துரைகளைப் பெறுங்கள். குணப்படுத்தல், பாதுகாப்பு, வளம் மற்றும் ஆன்மீக வளர்ச்சிக்கான உகந்த கற்களை கண்டறிந்து, அவற்றை எவ்வாறு தேர்ந்தெடுக்கவும், அணியவும், பராமரிக்கவும் என்பதை நிபுணர் வழிகாட்டுதலுடன் அதிக பயன் பெறுங்கள்.",

  "gemstone_power": "ரத்தின சக்தி",
  "unlock_your": "திறந்து விடுங்கள் உங்கள்",

  // Service Information
  "enter_details_for_gemstone_analysis": "ரத்தினப் பகுப்பாய்விற்கான உங்கள் விவரங்களை உள்ளிடுங்கள்",
  "complete_gemstone_analysis": "முழுமையான ரத்தினப் பகுப்பாய்வு",
  "service_price": "சேவை விலை",
  "comprehensive_gemstone_analysis_note": "கிரக பகுப்பாய்வுடன் தனிப்பயன் ரத்தின பரிந்துரைகள் மற்றும் அணியும் வழிகாட்டுதல்",

  // Form Fields
  "full_name": "முழுப் பெயர்",
  "enter_full_name": "உங்கள் முழுப் பெயரை உள்ளிடுங்கள்",
  "name_gemstone_resonance": "உங்கள் பெயர் அதிர்வுகள், ரத்தின ஒத்திசைவும் இணக்கத்தன்மையும் தீர்மானிக்க உதவுகின்றன",
  "email_address": "மின்னஞ்சல் முகவரி",
  "enter_email_address": "உங்கள் மின்னஞ்சல் முகவரியை உள்ளிடுங்கள்",
  "phone_number": "தொலைபேசி எண்",
  "enter_phone_number": "உங்கள் தொலைபேசி எண்ணை உள்ளிடுங்கள்",
  "gender": "பாலினம்",
  "male": "ஆண்",
  "female": "பெண்",
  "other": "மற்றவை",
  "date_of_birth": "பிறந்த தேதி",
  "birth_date_planetary_gemstones": "கிரகத் தாக்கங்களும் உகந்த ரத்தினங்களும் நிர்ணயிக்க இது அவசியம்",
  "time_of_birth": "பிறந்த நேரம்",
  "exact_time_gemstone_selection": "கிரக பலத்தை துல்லியமாக மதிப்பிட சரியான நேரம் தேவை",
  "place_of_birth": "பிறந்த இடம்",
  "place_of_birth_placeholder": "நகரம், மாநிலம், நாடு",
  "location_affects_gemstone_energy": "இடம், கிரக நிலைகள் மூலம் ரத்தினத் தேர்வை பாதிக்கிறது",
  "preferred_language": "விருப்ப மொழி",
  "english": "ஆங்கிலம்",
  "hindi": "ஹிந்தி",
  "telugu": "தெலுங்கு",
  "kannada": "கன்னடம்",
  "language_note": "உங்கள் ரத்தின வழிகாட்டி தேர்ந்தெடுத்த மொழியில் வழங்கப்படும்",

  // Core Gemstone Features
  "personalized_gemstone_recommendations": "தனிப்பயன் ரத்தின பரிந்துரைகள்",
  "planetary_gemstone_analysis": "கிரக-ரத்தின பகுப்பாய்வு",
  "healing_crystal_guidance_feature": "குணப்படுத்தும் கிரிஸ்டல் வழிகாட்டுதல்",
  "wearing_methods_timing": "அணியும் முறைகள் & உகந்த நேரம்",
  "gemstone_care_instructions": "ரத்தின பராமரிப்பு வழிமுறைகள்",
  "pdf_download": "முழுமையான PDF வழிகாட்டி",

  "what_you_get": "உங்கள் ரத்தினப் பகுப்பாய்வில் உள்ளவை",
  "personalized_gemstone_guide": "தனிப்பயன் ரத்தின வழிகாட்டி",
  "planetary_remedial_stones": "கிரக பரிகார ரத்தினங்கள்",
  "healing_crystal_recommendations": "குணப்படுத்தும் கிரிஸ்டல் பரிந்துரைகள்",
  "wearing_activation_guidance": "அணிதல் & ஆக்க செயல்பாட்டு வழிகாட்டுதல்",

  // Actions & Buttons
  "pay_and_get_gemstone_guidance": "என் ரத்தின வழிகாட்டியைப் பெறவும்",
  "processing_payment": "கட்டணம் செயலாக்கப்படுகிறது",
  "processing_request": "வழிகாட்டி உருவாக்கப்படுகிறது",

  // Payment & Success Messages
  "thank_you": "நன்றி",
  "payment_successful": "கட்டணம் வெற்றிகரமாக முடிந்தது!",
  "gemstone_analysis_processing": "உங்கள் தனிப்பட்ட ரத்தினப் பகுப்பாய்வை எங்கள் ரத்தின நிபுணர்கள் மற்றும் ஜோதிட நிபுணர்கள் தயாரித்து வருகின்றனர். குணப்படுத்தல் மற்றும் பரிகார ரத்தினங்களுக்கு விரிவான பரிந்துரைகள் வழங்கப்படும்.",
  "order_id": "ஆர்டர் ஐடி",
  "payment_id": "கட்டணம் ஐடி",
  "amount_paid": "செலுத்திய தொகை",

  // Delivery Information
  "delivery_information": "விநியோக தகவல்",
  "delivery_time": "வழிகாட்டி விநியோகம்",
  "within_12_hours_delivery_note": "உங்கள் விரிவான ரத்தின வழிகாட்டி 12 மணிநேரத்திற்குள் தயார் ஆகும்",
  "whatsapp_notification": "WhatsApp புதுப்பிப்புகள்",
  "whatsapp_delivery_note": "WhatsApp-ல் உடனடி அறிவிப்புகள் பெறுங்கள்",
  "email_delivery": "மின்னஞ்சல் விநியோகம்",
  "email_delivery_note": "முழு வழிகாட்டி அனுப்பப்படும் முகவரி",

  // What You'll Receive
  "what_youll_receive": "உங்கள் ரத்தின வழிகாட்டி தொகுப்பு",
  "detailed_gemstone_report_pdf": "விரிவான ரத்தின அறிக்கை (PDF)",
  "personalized_stone_recommendations": "தனிப்பயன் கல் பரிந்துரைகள்",
  "planetary_remedial_guidance": "கிரக பரிகார வழிகாட்டுதல்",
  "wearing_activation_methods": "அணிதல் & ஆக்க செயல்முறைகள்",
  "gemstone_care_maintenance": "ரத்தின பராமரிப்பு & பேணுதல்",

  // Visual Content
  "sample_gemstone_analysis": "மாதிரி ரத்தினப் பகுப்பாய்வு",
  "recommended_gemstone": "பரிந்துரைக்கப்பட்ட ரத்தினம்",
  "sample_gemstone_reading": "சனிப் பலத்தை உயர்த்தவும் ஞானத்தை மேம்படுத்தவும் நீலம் (நீலம் சாப்பெயர்)",
  "sample_gemstone_preview": "குணப்படுத்தும் பண்புகளுடன் உங்கள் தனிப்பயன் ரத்தின பரிந்துரைகளின் முன்னோட்டம்",
  "gemstone_categories": "ரத்தின வகைகள்",

  // Gemstone Types
  "ruby": "மாணிக்கம் (Ruby)",
  "emerald": "மரகதம் (Emerald)",
  "sapphire": "சாப்பெயர் (Sapphire)",
  "diamond": "வஜ்ரம்/வைரம் (Diamond)",
  "yellow_sapphire": "புஷ்பராகம் (Yellow Sapphire)",
  "coral": "மூங்கா (Coral)",

  // Status & Processing
  "your_gemstone_analysis_status": "உங்கள் ரத்தினப் பகுப்பாய்வு நிலை",
  "processing_your_analysis": "உங்கள் ரத்தினத் தேவைகள் ஆய்வு செய்யப்படுகிறது",
  "analysis_processing_message": "குணப்படுத்தல், பாதுகாப்பு, வளம் ஆகியவற்றிற்கான உகந்த ரத்தினங்களை பரிந்துரைக்க உங்கள் ஜாதகம் ஆய்வு செய்யப்படுகிறது.",
  "request_id": "பகுப்பாய்வு ஐடி",
  "status": "நிலை",
  "processing": "நடைபெறுகிறது",
  "pending": "வரிசையில் உள்ளது",
  "email_notification_sent": "உறுதிப்படுத்தும் மின்னஞ்சல் அனுப்பப்பட்டது",
  "whatsapp_update_coming": "WhatsApp புதுப்பிப்புகள் இயலுமைப்படுத்தப்பட்டுள்ளன",
  "delivery_within_12_hours": "வழிகாட்டி 12 மணிநேரத்தில் தயார்",

  // Support & Contact
  "contact_support": "ரத்தின ஆதரவைத் தொடர்புகொள்ளுங்கள்",
  "need_help": "வழிகாட்டல் வேண்டுமா?",
  "contact_us_at": "எங்களை அணுக",

  // Error Messages
  "please_fill_all_required_fields": "தேவையான அனைத்து பிறப்பு விவரங்களையும் பூர்த்தி செய்யுங்கள்",
  "payment_failed": "கட்டணம் தோல்வியடைந்தது. தயவு செய்து மீண்டும் முயற்சிக்கவும்.",
  "processing_failed": "பகுப்பாய்வு செயலாக்கம் தோல்வியடைந்தது. எங்கள் ஆதரவுடன் தொடர்புகொள்ளுங்கள்.",

  // Planetary Gemstones
  "sun_gemstones": "சூரியன் — ரத்தினங்கள்",
  "moon_gemstones": "சந்திரன் — ரத்தினங்கள்",
  "mars_gemstones": "செவ்வாய் — ரத்தினங்கள்",
  "mercury_gemstones": "புதன் — ரத்தினங்கள்",
  "jupiter_gemstones": "வியாழன் — ரத்தினங்கள்",
  "venus_gemstones": "சுக்கிரன் — ரத்தினங்கள்",
  "saturn_gemstones": "சனி — ரத்தினங்கள்",
  "rahu_gemstones": "ராகு — ரத்தினங்கள்",
  "ketu_gemstones": "கேது — ரத்தினங்கள்",

  // Primary Gemstones
  "ruby_manik": "மாணிக்கம் (மாணிக்/Manik)",
  "pearl_moti": "முத்து (மோதி/Moti)",
  "coral_moonga": "சிவப்பு மூங்கா (Moonga)",
  "emerald_panna": "மரகதம் (பண்ணா/Panna)",
  "yellow_sapphire_pukhraj": "புஷ்பராகம் (புக்ராஜ்/Pukhraj)",
  "diamond_heera": "வைரம் (ஹீரா/Heera)",
  "blue_sapphire_neelam": "நீலம் (நீலம்/Neelam)",
  "hessonite_gomed": "கோமேதகம் (கோமேட்/Gomed)",
  "cats_eye_lehsunia": "வேடூரியம் (லஹ்சுனியா/Lehsunia)",

  // Secondary Gemstones
  "garnet": "கார்நெட்",
  "moonstone": "மூன் ஸ்டோன்",
  "carnelian": "கார்னேலியன்",
  "peridot": "பெரிடாட்",
  "citrine": "சிட்ரீன்",
  "opal": "ஓபல்",
  "amethyst": "அமேதிஸ்ட்",
  "agate": "அகேட்",
  "onyx": "ஒனிக்ஸ்",

  // Healing Crystals
  "rose_quartz": "ரோஸ் குவார்ட்ஸ்",
  "clear_quartz": "க்ளியர் குவார்ட்ஸ்",
  "amethyst_crystal": "அமேதிஸ்ட் கிரிஸ்டல்",
  "citrine_crystal": "சிட்ரீன் கிரிஸ்டல்",
  "black_tourmaline": "பிளாக் டூர்மாலைன்",
  "green_aventurine": "கிரீன் அவென்சுரைன்",
  "tigers_eye": "டைகர்ஸ் ஐ",
  "labradorite": "லாப்ரடோரைட்",
  "fluorite": "ஃப்ளோரைட்",

  // Gemstone Properties
  "healing_properties": "குணப்படுத்தும் பண்புகள்",
  "protective_properties": "பாதுகாப்பு பண்புகள்",
  "prosperity_properties": "வளம் தரும் பண்புகள்",
  "spiritual_properties": "ஆன்மீக பண்புகள்",
  "emotional_properties": "உணர்ச்சி குணப்படுத்தும் பண்புகள்",
  "physical_properties": "உடல் நலம் சார்ந்த பண்புகள்",

  // Gemstone Selection Criteria
  "planetary_strength": "கிரக பலம் — பகுப்பாய்வு",
  "weak_planets": "பலவீன கிரகங்கள் — அடையாளம்",
  "malefic_planets": "பாப கிரகங்கள் — பகுப்பாய்வு",
  "benefic_enhancement": "சுப கிரக பலம் உயர்த்தல்",
  "doshas_correction": "தோஷ சரிசெய்தல்",
  "yogas_strengthening": "யோக பலப்படுத்தல்",

  // Quality & Authenticity
  "gemstone_quality": "ரத்தின தர வழிகாட்டுதல்கள்",
  "authenticity_check": "நம்பகத்தன்மை சரிபார்ப்பு",
  "certification_importance": "சான்றிதழ் முக்கியத்துவம்",
  "natural_vs_synthetic": "இயற்கை vs செயற்கை கற்கள்",
  "treatment_disclosure": "சிகிச்சை/மேம்பாட்டு தகவல் வெளிப்பாடு",
  "origin_significance": "உற்பத்தி இடம்/மூலம் — முக்கியத்துவம்",

  // Wearing Guidelines
  "wearing_finger": "அணியும் விரல் — வழிகாட்டுதல்",
  "wearing_day": "அணிய உகந்த நாள்",
  "wearing_time": "அணிய சிறந்த நேரம்",
  "metal_selection": "அமைப்பதற்கான உலோகத் தேர்வு",
  "weight_calculation": "ரத்தின எடை கணக்கீடு",
  "purification_ritual": "சுத்திகரிப்பு & ஆக்க செயல்பாட்டு அனுஷ்டானம்",

  // Gemstone Care
  "cleaning_methods": "சுத்தம் & பராமரிப்பு முறைகள்",
  "storage_guidelines": "சரியான சேமிப்பு வழிமுறைகள்",
  "energizing_techniques": "மறு-ஆற்றலூட்டும் முறைகள்",
  "avoid_damage": "சேதம் தவிர்க்கும் குறிப்புகள்",
  "periodic_cleansing": "காலகட்ட சுத்திகரிப்பு அனுஷ்டானங்கள்",
  "replacement_timing": "மாற்றுதல் & மேம்படுத்தும் நேரம்",

  // Benefits & Effects
  "career_benefits": "தொழில் & வணிக நன்மைகள்",
  "health_benefits": "ஆரோக்கிய & நல நன்மைகள்",
  "relationship_benefits": "உறவு & காதல் நன்மைகள்",
  "financial_benefits": "நிதி & வள நன்மைகள்",
  "spiritual_benefits": "ஆன்மீக வளர்ச்சி நன்மைகள்",
  "protection_benefits": "பாதுகாப்பு & பாதுகாப்புத் துணை",

  // Timing & Muhurat
  "auspicious_timing": "சுப வாங்கும் நேரம்",
  "wearing_muhurat": "அணியும் முஹூர்த்தக் கணக்கீடு",
  "activation_timing": "ஆக்க செயல்பாட்டு நேரம்",
  "eclipse_precautions": "கிரகண கால முன்னெச்சரிக்கைகள்",
  "festival_significance": "விழா & சிறப்பு நாளின் முக்கியத்துவம்",
  "monthly_guidelines": "மாதாந்திர அணியும் வழிகாட்டுதல்கள்",

  // Combination Guidelines
  "gemstone_combinations": "பயன் தரும் ரத்தின இணைப்புகள்",
  "conflicting_stones": "மோதும் கல் இணைப்புகள்",
  "layered_wearing": "பல அடுக்குகளாக அணியும் வழிகாட்டுதல்",
  "rotation_schedule": "ரத்தின மாற்றம்/சுழற்சி அட்டவணை",
  "seasonal_preferences": "஋துக்கேற்ற ரத்தின விருப்பங்கள்",
  "occasion_selection": "நிகழ்ச்சி அடிப்படையிலான தேர்வு",

  // Alternative Options
  "budget_alternatives": "பட்ஜெட்டுக்கு ஏற்ற மாற்று விருப்பங்கள்",
  "substitute_stones": "மாற்று கல் விருப்பங்கள்",
  "semi_precious_options": "அரைமதிப்புள்ள கற்கள் — மாற்றுகள்",
  "synthetic_alternatives": "செயற்கை கற்கள் — மாற்றுகள்",
  "crystal_alternatives": "கிரிஸ்டல் & கனிம மாற்றுகள்",
  "rudraksha_combinations": "ருத்ராட்ச இணைப்புகள்",

  // Special Categories
  "bridal_gemstones": "மணமகள் ரத்தினத் தேர்வு",
  "childrens_gemstones": "குழந்தைகளுக்கான ரத்தின வழிகாட்டுதல்",
  "elderly_recommendations": "மூத்தவர்களுக்கான பரிந்துரைகள்",
  "professional_stones": "தொழில்/பணிக்கான ரத்தினங்கள்",
  "students_gemstones": "மாணவர்கள் & கல்விக்கான கற்கள்",
  "artists_stones": "படைப்பாளிகளுக்கான கற்கள்",

  // Astrological Factors
  "ascendant_stones": "லக்னத்தை அடிப்படையாகக் கொண்ட கல் தேர்வு",
  "moon_sign_stones": "சந்திர ராசி — ரத்தின வழிகாட்டுதல்",
  "sun_sign_influence": "சூரிய ராசி — தேர்வில் தாக்கம்",
  "navamsa_considerations": "நவாம்ச சார்ட் கருத்தில் கொள்ளல்",
  "dasha_period_stones": "தசா காலத்திற்கு உகந்த கற்கள்",
  "transit_considerations": "தற்போதைய கோச்சார கருத்துகள்",

  // Consultation Features
  "expert_consultation": "ரத்தின நிபுணர் ஆலோசனை",
  "follow_up_guidance": "பின்தொடரும் வழிகாட்டுதல் கிடைக்கும்",
  "customization_options": "தனிப்பயன் & விருப்பப்படுத்தல்",
  "update_recommendations": "புதுப்பிக்கப்பட்ட பரிந்துரைகள்",
  "progress_tracking": "நன்மைகள் முன்னேற்ற கண்காணிப்பு",
  "adjustment_guidance": "சரிசெய்தல் & நுண்-அமைப்பு வழிகாட்டுதல்",

  // Regional Preferences
  "indian_gemstones": "இந்திய மூல ரத்தினங்கள்",
  "burmese_stones": "பர்மா மூல கற்கள்",
  "ceylon_sapphires": "இலங்கை (சீலோன்) நீலம் — சிறப்பு",
  "kashmir_sapphires": "காஷ்மீர் நீலம் — பிரீமியம்",
  "colombian_emeralds": "கொலம்பிய மரகதம் — மேன்மை",
  "african_gemstones": "ஆப்பிரிக்கா மூல ரத்தினங்கள்",

  // Modern Applications
  "technology_enhancement": "தொழில்நுட்ப & டிஜிட்டல் வாழ்க்கை மேம்பாடு",
  "stress_relief": "இக்கால மனஅழுத்த நிவாரண முறைகள்",
  "urban_living": "நகர வாழ்க்கைக்கான ரத்தினத் தேவைகள்",
  "travel_protection": "பயணம் & பயணப் பாதுகாப்பு",
  "workspace_harmony": "பணியிடம் ஒற்றுமைக்கான கற்கள்",
  "social_confidence": "சமூக நம்பிக்கை உயர்த்திகள்"
};
